var _ = /* @__PURE__ */ ((p) => (p[p.Low = -1] = "Low", p[p.Normal = 0] = "Normal", p[p.High = 1] = "High", p))(_ || {});
async function i(p) {
  var a;
  const e = {
    importPixi: !1,
    ...p
  };
  e.app && (e.renderer = e.app.renderer, e.stage = e.app.stage), e.importPixi && !e.pixi && (e.pixi = await import("pixi.js")), window.__PIXI_DEVTOOLS__ = {
    ...window.__PIXI_DEVTOOLS__ || {},
    app: e.app,
    stage: e.stage,
    renderer: e.renderer,
    extensions: [...((a = window.__PIXI_DEVTOOLS__) == null ? void 0 : a.extensions) || [], ...e.extensions || []],
    plugins: {}
  };
}
export {
  _ as ExtensionPriority,
  i as initDevtools
};
